import React from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaShieldAlt } from 'react-icons/fa';

const Adatvedelem: React.FC = () => {
  const contactDetails = [
    { icon: <FaPhone />, text: 'Nagy Péter Villanyszerelő mester', phone: '+36703620652' },
    { icon: <FaPhone />, text: 'Tamasi Krisztán villamosbiztonsági felülvizsgáló', phone: '+36706049889' },
    { icon: <FaEnvelope />, text: 'kelectrokft@gmail.com', link: 'mailto:kelectrokft@gmail.com' },
    { icon: <FaMapMarkerAlt />, text: 'SZOLNOK és 100km-es körzete' }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-64 bg-gradient-to-r from-blue-600 to-blue-800">
        <div className="relative z-10 container mx-auto px-4 h-full flex flex-col justify-center items-center text-center text-white">
          <FaShieldAlt className="text-5xl mb-4 opacity-80" />
          <h1 className="text-4xl font-bold mb-4">
            Adatvédelmi Szabályzat
          </h1>
          <p className="text-xl">
            Cookie szabályzat és adatkezelési tájékoztató
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          
          {/* 1. Adatkezelő bemutatása */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-blue-600 pb-2">
              1. Adatkezelő bemutatása
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>Adatkezelő neve:</strong> K-Electro Kft.</p>
              <p><strong>Cégjegyzékszám:</strong> 13-09-216399</p>
              <p><strong>Adószám:</strong> 27489394-2-13</p>
              <p><strong>Székhely:</strong> 2740 Abony, Mikes Kelemen utca 36</p>
              <p><strong>Elérhetőség:</strong></p>
              <ul className="ml-6 space-y-2">
                <li>• <strong>Email:</strong> kelectrokft@gmail.com</li>
                <li>• <strong>Telefon:</strong> Nagy Péter: +36703620652</li>
                <li>• <strong>Telefon:</strong> Tamasi Krisztán: +36706049889</li>
                <li>• <strong>Működési terület:</strong> Szolnok és 100 km-es körzete</li>
              </ul>
            </div>
          </div>

          {/* 2. Kezelt adatok köre */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-blue-600 pb-2">
              2. Kezelt személyes adatok köre
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>2.1. Kapcsolatfelvételi űrlap:</strong></p>
              <ul className="ml-6 space-y-2">
                <li>• Név</li>
                <li>• Email cím</li>
                <li>• Üzenet tartalma</li>
                <li>• IP cím (automatikusan)</li>
              </ul>
              
              <p><strong>2.2. Telefonos megkeresés:</strong></p>
              <ul className="ml-6 space-y-2">
                <li>• Név</li>
                <li>• Telefonszám</li>
                <li>• Szolgáltatással kapcsolatos információk</li>
              </ul>

              <p><strong>2.3. Helyszíni felmérés:</strong></p>
              <ul className="ml-6 space-y-2">
                <li>• Név, elérhetőség</li>
                <li>• Lakcím/munkavégzés helye</li>
                <li>• Technikai adatok (elektromos rendszerrel kapcsolatos)</li>
              </ul>
            </div>
          </div>

          {/* 3. Adatkezelés célja */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-blue-600 pb-2">
              3. Adatkezelés célja és jogalapja
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>3.1. Szolgáltatás nyújtása:</strong></p>
              <ul className="ml-6 space-y-2">
                <li>• Ajánlat készítése</li>
                <li>• Kapcsolattartás</li>
                <li>• Munkavégzés koordinálása</li>
                <li>• Számlázás</li>
              </ul>
              
              <p><strong>3.2. Jogalap:</strong> GDPR 6. cikk (1) bekezdés b) pont - szerződés teljesítése</p>
              <p><strong>3.3. Hozzájárulás alapú adatkezelés:</strong> Hírlevél küldése (amennyiben feliratkozik)</p>
            </div>
          </div>

          {/* 4. Cookie-k használata */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-blue-600 pb-2">
              4. Cookie-k használata
            </h2>
            <div className="space-y-6 text-gray-700">
              
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-3">4.1. Szükséges cookie-k</h3>
                <p>A weboldal alapvető működéséhez szükségesek. Nem tárolnak személyes adatokat.</p>
                <ul className="ml-6 space-y-1 mt-2">
                  <li>• Munkamenet azonosítók</li>
                  <li>• Biztonsági beállítások</li>
                  <li>• Cookie preferenciák</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-3">4.2. Analitikai cookie-k</h3>
                <p>Segítenek megérteni, hogyan használják a látogatók a weboldalt.</p>
                <ul className="ml-6 space-y-1 mt-2">
                  <li>• Látogatottsági statisztikák</li>
                  <li>• Legnépszerűbb oldalak</li>
                  <li>• Forgalmi források</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-3">4.3. Marketing cookie-k</h3>
                <p>Releváns hirdetések megjelenítésére használjuk.</p>
                <ul className="ml-6 space-y-1 mt-2">
                  <li>• Hirdetési preferenciák</li>
                  <li>• Remarketing</li>
                  <li>• Konverziók mérése</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-3">4.4. Funkcionális cookie-k</h3>
                <p>Továbbfejlesztett funkciókat biztosítanak.</p>
                <ul className="ml-6 space-y-1 mt-2">
                  <li>• Nyelvi beállítások</li>
                  <li>• Régió preferenciák</li>
                  <li>• Űrlap adatok ideiglenes mentése</li>
                </ul>
              </div>
            </div>
          </div>

          {/* 5. Adatok tárolása */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-blue-600 pb-2">
              5. Adatok tárolása és törlése
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>5.1. Tárolási idő:</strong></p>
              <ul className="ml-6 space-y-2">
                <li>• Kapcsolatfelvételi adatok: 3 év (garancia időszak)</li>
                <li>• Számlázási adatok: 8 év (számviteli törvény)</li>
                <li>• Cookie-k: 1-2 év (típustól függően)</li>
                <li>• Hírlevél adatok: visszavonásig</li>
              </ul>
              <p><strong>5.2.</strong> Az adatok automatikus törlése a megadott időszak lejártával.</p>
              <p><strong>5.3.</strong> Kérésre azonnali törlés (kivéve jogszabály által előírt megőrzési kötelezettség).</p>
            </div>
          </div>

          {/* 6. Érintetti jogok */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-blue-600 pb-2">
              6. Az érintett jogai
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>Az érintett jogosult:</strong></p>
              <ul className="ml-6 space-y-2">
                <li>• <strong>Tájékoztatás kérése:</strong> milyen adatokat kezelünk róla</li>
                <li>• <strong>Helyesbítés:</strong> hibás adatok javítása</li>
                <li>• <strong>Törlés:</strong> "elfeledtetéshez való jog"</li>
                <li>• <strong>Korlátozás:</strong> adatkezelés korlátozása</li>
                <li>• <strong>Hordozhatóság:</strong> adatok átadása más szolgáltatónak</li>
                <li>• <strong>Tiltakozás:</strong> adatkezelés ellen</li>
                <li>• <strong>Panasz:</strong> felügyeleti hatóságnál (NAIH)</li>
              </ul>
              <p><strong>Joggyakorlás:</strong> kelectrokft@gmail.com emailen vagy telefonon.</p>
            </div>
          </div>

          {/* 7. Adatbiztonság */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-blue-600 pb-2">
              7. Adatbiztonság
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>7.1.</strong> Technikai és szervezési intézkedések:</p>
              <ul className="ml-6 space-y-2">
                <li>• SSL titkosítás</li>
                <li>• Biztonságos adattárolás</li>
                <li>• Hozzáférés korlátozása</li>
                <li>• Rendszeres biztonsági mentések</li>
              </ul>
              <p><strong>7.2.</strong> Adatvédelmi incidens esetén 72 órán belül jelentés a hatóságnak.</p>
            </div>
          </div>

          {/* 8. Harmadik felek */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-blue-600 pb-2">
              8. Harmadik felek szolgáltatásai
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>8.1. Használt külső szolgáltatások:</strong></p>
              <ul className="ml-6 space-y-2">
                <li>• <strong>Formspree:</strong> Kapcsolatfelvételi űrlap kezelése</li>
                <li>• <strong>Google Analytics:</strong> Látogatottsági statisztikák (ha engedélyezve)</li>
                <li>• <strong>Hosting szolgáltató:</strong> Weboldal tárolása</li>
              </ul>
              <p><strong>8.2.</strong> Minden külső szolgáltató GDPR kompatibilis.</p>
              <p><strong>8.3.</strong> Adatokat csak szükséges mértékben osztunk meg.</p>
            </div>
          </div>

          {/* 9. Kapcsolatfelvétel */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-blue-600 pb-2">
              9. Kapcsolatfelvétel adatvédelmi ügyekben
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>Adatvédelmi kérdések esetén forduljon hozzánk:</strong></p>
              <ul className="ml-6 space-y-2">
                <li>• <strong>Email:</strong> kelectrokft@gmail.com</li>
                <li>• <strong>Telefon:</strong> Nagy Péter: +36703620652</li>
                <li>• <strong>Telefon:</strong> Tamasi Krisztán: +36706049889</li>
              </ul>
              <p><strong>Válaszidő:</strong> 30 napon belül írásban válaszolunk.</p>
            </div>
          </div>

          {/* 10. Hatálybalépés */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-blue-600 pb-2">
              10. Hatálybalépés és módosítás
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>10.1.</strong> Jelen adatvédelmi szabályzat 2024. január 1-jétől hatályos.</p>
              <p><strong>10.2.</strong> Módosítás esetén a weboldalon tájékoztatjuk a látogatókat.</p>
              <p><strong>10.3.</strong> Jelentős változások esetén külön értesítést küldünk.</p>
            </div>
          </div>

          {/* Cookie táblázat */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-blue-600 pb-2">
              11. Cookie-k részletes listája
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full border border-gray-200 rounded-lg">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left font-semibold text-gray-800 border-b">Cookie neve</th>
                    <th className="px-4 py-3 text-left font-semibold text-gray-800 border-b">Típus</th>
                    <th className="px-4 py-3 text-left font-semibold text-gray-800 border-b">Célja</th>
                    <th className="px-4 py-3 text-left font-semibold text-gray-800 border-b">Élettartam</th>
                  </tr>
                </thead>
                <tbody className="text-gray-700">
                  <tr className="border-b">
                    <td className="px-4 py-3">cookieConsent</td>
                    <td className="px-4 py-3">Szükséges</td>
                    <td className="px-4 py-3">Cookie preferenciák tárolása</td>
                    <td className="px-4 py-3">1 év</td>
                  </tr>
                  <tr className="border-b">
                    <td className="px-4 py-3">sessionId</td>
                    <td className="px-4 py-3">Szükséges</td>
                    <td className="px-4 py-3">Munkamenet azonosítása</td>
                    <td className="px-4 py-3">Munkamenet vége</td>
                  </tr>
                  <tr className="border-b">
                    <td className="px-4 py-3">_ga</td>
                    <td className="px-4 py-3">Analitikai</td>
                    <td className="px-4 py-3">Google Analytics látogató azonosítás</td>
                    <td className="px-4 py-3">2 év</td>
                  </tr>
                  <tr className="border-b">
                    <td className="px-4 py-3">_gat</td>
                    <td className="px-4 py-3">Analitikai</td>
                    <td className="px-4 py-3">Google Analytics kérések korlátozása</td>
                    <td className="px-4 py-3">1 perc</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3">preferences</td>
                    <td className="px-4 py-3">Funkcionális</td>
                    <td className="px-4 py-3">Felhasználói beállítások</td>
                    <td className="px-4 py-3">1 év</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Hatálybalépés info */}
          <div className="bg-blue-50 p-6 rounded-lg border-l-4 border-blue-600">
            <p className="text-gray-700 font-medium">
              <strong>Hatálybalépés:</strong> 2024. január 1.<br/>
              <strong>Utolsó módosítás:</strong> 2024. január 1.<br/>
              <strong>GDPR megfelelőség:</strong> EU 2016/679 rendelet szerint<br/>
              <strong>Felügyeleti hatóság:</strong> NAIH (Nemzeti Adatvédelmi és Információszabadság Hatóság)
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 bg-gray-900 text-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-12">
            Kérjen Árajánlatot!
          </h2>
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div>
              <h3 className="text-2xl font-semibold mb-6">Elérhetőségeink</h3>
              <div className="space-y-4">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center text-white text-xl">
                    📞
                  </div>
                  <div>
                    <div className="font-medium">Nagy Péter Villanyszerelő mester</div>
                    <a 
                      href="tel:+36703620652"
                      className="text-red-400 hover:text-red-300 font-semibold transition-colors"
                    >
                      +36703620652
                    </a>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center text-white text-xl">
                    📞
                  </div>
                  <div>
                    <div className="font-medium">Tamasi Krisztán villamosbiztonsági felülvizsgáló</div>
                    <a 
                      href="tel:+36706049889"
                      className="text-red-400 hover:text-red-300 font-semibold transition-colors"
                    >
                      +36706049889
                    </a>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center text-white text-xl">
                    ✉️
                  </div>
                  <div>
                    <a 
                      href="mailto:kelectrokft@gmail.com"
                      className="hover:text-red-400 transition-colors"
                    >
                      kelectrokft@gmail.com
                    </a>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center text-white text-xl">
                    📍
                  </div>
                  <div>
                    <span>SZOLNOK és 100km-es körzete</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-800 p-6 rounded-xl">
              <h3 className="text-xl font-semibold mb-4">Gyors kapcsolatfelvétel</h3>
              <p className="text-gray-300 mb-4">
                Hívjon minket bizalommal! Ingyenes helyszíni felméréssel és 
                részletes árajánlattal várjuk megkeresését.
              </p>
              <div className="space-y-2">
                <p className="text-red-400 font-semibold">📞 Azonnali válasz</p>
                <p className="text-red-400 font-semibold">📋 Ingyenes felmérés</p>
                <p className="text-red-400 font-semibold">💰 Versenyképes árak</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Adatvedelem;
